'use client'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'
import Link from 'next/link'
import WithQueryParams from '@/hoc/withQueryParams'

import Icon from '@/components/atoms/Icon'
import Button from '@/components/atoms/Button'
import { ButtonSize } from '@/components/atoms/Button/Button.types'
import { ButtonLabel } from '@/components/atoms/Typography'
import styles from './ApplyLink.module.scss'

const ApplyLink = ({
  href,
  label,
  autoWidth = false,
  className,
  size,
  uppercase = true,
  source,
  disabled = false,
}: {
  href: string
  label: string
  autoWidth?: boolean
  className?: string
  size?: ButtonSize
  uppercase?: boolean
  source?: string
  disabled?: boolean
}) => {
  const t = useTranslations('General')
  const onClick = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ apply_link_clicked: source })
    }
  }

  const buttonLabel = disabled ? t('comingSoon') : label

  let buttonProps = {}
  if (!disabled) {
    buttonProps = {
      href,
      onClick,
      as: Link,
      Icon: () => <Icon iconName='ArrowRight' />,
    }
  }

  return (
    <Button
      size={size}
      {...buttonProps}
      className={clsx(styles.link, uppercase && styles.uppercase, className)}
      autoWidth={autoWidth}
      disabled={disabled}
    >
      <ButtonLabel
        size='md'
        family='serif'
      >
        {buttonLabel}
      </ButtonLabel>
    </Button>
  )
}

export default WithQueryParams(ApplyLink)
